module.exports = __webpack_public_path__ + "static/img/003_TO8_1461_og.d68a499.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/003_TO8_1461_og.jpg
// module id = wxWw
// module chunks = 0